import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/pageViewTracking';

// Renders nothing — fires a normalized page_view to the GTM data layer on
// mount and on every client-side route change. Must be rendered inside a
// Router so useLocation has context.
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
